import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';

/**
 * Phase 40 · Cookie Policy — versione ufficiale Nymia/Bull Marketing S.r.l.s.
 *
 * Documento redatto ai sensi dell'art. 122 del Codice Privacy (D.Lgs. 196/2003
 * come modificato dal D.Lgs. 101/2018), del Regolamento (UE) 2016/679 (GDPR),
 * della Direttiva 2002/58/CE (ePrivacy), del Provvedimento del Garante per la
 * protezione dei dati personali n. 231 del 10 giugno 2021 e del Regolamento
 * (UE) 2022/2065 (DSA). Descrive esclusivamente cookie e tecnologie di
 * archiviazione locale realmente utilizzati dalla Piattaforma alla data di
 * ultimo aggiornamento.
 */
const SECTION_IDS = [
  'introduction',
  'controller',
  'what_are_cookies',
  'nymia_approach',
  'technologies_used',
  'essential',
  'functional',
  'analytics',
  'marketing',
  'third_party_cookies',
  'legal_basis',
  'consent_banner',
  'how_to_manage',
  'browser_settings',
  'international_transfers',
  'retention',
  'user_rights',
  'changes',
  'verification_required',
  'contact',
];

// Data di ultima revisione ufficiale del documento.
const LAST_UPDATED = '2026-02-12';

const CookiesPage = () => {
  const { t } = useTranslation('legal');
  const sections = SECTION_IDS.map((id) => ({
    id,
    title: t(`cookies.sections.${id}`),
  }));

  return (
    <LegalPageLayout
      namespace="legal"
      eyebrow="Nymia · Cookie Policy"
      title={t('cookies.title')}
      subtitle={t('cookies.subtitle')}
      lastUpdated={LAST_UPDATED}
      sections={sections}
      testId="cookies-page"
    >
      {SECTION_IDS.map((id) => (
        <LegalSection
          key={id}
          id={id}
          title={t(`cookies.sections.${id}`)}
          body={t(`cookies.body.${id}`, { defaultValue: '' })}
          testId={`cookies-section-${id}`}
        />
      ))}
    </LegalPageLayout>
  );
};

export default CookiesPage;
